import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { slideInFromBottomNFadeNZoom } from '../../../../web/styles/animations';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
		padding: THEME.spacing.lg,
		boxSizing: 'border-box',
		maxWidth: 720,
		margin: '0 auto',
	},
	footer: {
		display: 'flex',
		justifyContent: 'center',
		paddingBottom: THEME.spacing.xxl,
	},
	closeButton: {
		minWidth: 200,
	},
	stepEnter: {
		animationName: [slideInFromBottomNFadeNZoom()],
		animationDuration: '260ms',
		animationFillMode: 'both',
		animationTimingFunction: 'ease-out',
		'@media (prefers-reduced-motion: reduce)': {
			animationName: 'none',
		},
	},
	intro: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
	panel: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.md,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: THEME.colors.background.light,
	},
	eyebrow: {
		fontFamily: THEME.typography.fontFamilies.sora,
		fontSize: THEME.typography.fontSizes.xxs,
		fontWeight: THEME.typography.fontWeights.bold,
		letterSpacing: 1,
		textTransform: 'uppercase',
		color: THEME.colors.text.light,
	},
	targetName: {
		fontFamily: THEME.typography.fontFamilies.sora,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	scopeLine: {
		borderLeft: `3px solid ${THEME.colors.danger.main}`,
		backgroundColor: THEME.colors.danger.light,
		borderRadius: THEME.common.borderRadius,
		padding: THEME.spacing.sm,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
	},
	selectTrigger: {
		minWidth: 320,
	},
	gateHint: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
	dropzone: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: THEME.spacing.xs,
		padding: THEME.spacing.xl,
		border: `1px dashed ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: THEME.colors.background.main,
		cursor: 'pointer',
		textAlign: 'center',
		color: THEME.colors.text.light,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		transition: 'border-color 120ms ease, background-color 120ms ease',
		'@media (prefers-reduced-motion: reduce)': {
			transition: 'none',
		},
		':focus-visible': {
			outline: `2px solid ${THEME.colors.primary.main}`,
			outlineOffset: 2,
		},
	},
	dropzoneActive: {
		borderColor: THEME.colors.primary.main,
		backgroundColor: THEME.colors.hover.light,
	},
	hiddenInput: {
		display: 'none',
	},
	previewFrame: {
		backgroundColor: THEME.colors.background.main,
		borderRadius: THEME.common.borderRadius,
		padding: THEME.spacing.md,
	},
	resultPanel: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.md,
		borderRadius: THEME.common.borderRadius,
		border: `1px solid ${THEME.colors.success.main}`,
		backgroundColor: THEME.colors.success.subtle.light,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
	},
	resultPanelPartial: {
		borderColor: THEME.colors.warning.main,
		backgroundColor: THEME.colors.warning.light,
	},
	failedCount: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.danger.main,
	},
	counts: {
		fontFamily: THEME.typography.fontFamilies.sora,
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	warningsTitle: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.warning.main,
	},
	warningsList: {
		margin: 0,
		paddingLeft: THEME.spacing.lg,
		color: THEME.colors.warning.main,
	},
	dialogTitle: {
		paddingRight: THEME.spacing.lg,
	},
	confirmBody: {
		display: 'flex',
		flexDirection: 'column',
		fontSize: THEME.typography.fontSizes.sm,
		gap: THEME.spacing.sm,
	},
});
